import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT } from "../data/apartments";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="main-footer" className="bg-charcoal border-t border-gold/15">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Sakurų namai" className="w-12 h-12 rounded-full object-cover border border-gold/40 bg-white" />
            <span className="brand-logo text-2xl text-cream">Sakurų namai</span>
          </div>
          <p className="text-sm text-cream/50 mt-4 leading-relaxed max-w-xs font-sans">
            {t("home.tagline")}
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold/70 mb-5">{t("nav.contact")}</h4>
          <ul className="space-y-3 text-sm text-cream/70 font-sans">
            <li>
              <a href={`tel:${CONTACT.phone}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-gold transition-colors">
                <Phone size={16} className="text-gold/70" /> {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-gold transition-colors">
                <Mail size={16} className="text-gold/70" /> {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={16} className="text-gold/70" /> {CONTACT.address}
            </li>
          </ul>
          <div className="flex items-center gap-3 mt-6">
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram"
              className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold/80 hover:bg-gold/10 hover:text-gold transition-colors">
              <Instagram size={18} />
            </a>
            <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook"
              className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold/80 hover:bg-gold/10 hover:text-gold transition-colors">
              <Facebook size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold/70 mb-5">{t("nav.home")}</h4>
          <ul className="space-y-2 text-sm text-cream/70 font-sans">
            <li><Link to="/projektas" className="hover:text-gold transition-colors">{t("nav.about")}</Link></li>
            <li><Link to="/migdolas" className="hover:text-gold transition-colors">{t("nav.migdolas")}</Link></li>
            <li><Link to="/vysnia" className="hover:text-gold transition-colors">{t("nav.vysnia")}</Link></li>
            <li><Link to="/vieta" className="hover:text-gold transition-colors">{t("nav.location")}</Link></li>
            <li><Link to="/galerija" className="hover:text-gold transition-colors">{t("nav.gallery")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-cream/40 font-sans">© {new Date().getFullYear()} Sakurų namai. {t("common.allRights")}</p>
          <p className="text-xs text-cream/40 font-sans">Architektas G. Vieversys · Energinė klasė A++</p>
        </div>
      </div>
    </footer>
  );
};
